<template>
  <div>
    <h6 class="heading-small text-muted mb-4 text-truncate">
      <span v-if="paymentTypeData === null">Create Payment Type</span>
      <span v-else>Update Payment Type</span>
    </h6>

    <form id="form-proper">
      <div class="py-2" style="border-bottom: 1px solid #e0e0e0">
        <div class="row">
          <div class="col">
            <base-input label="Name" required>
              <a-input
                v-model.trim="$v.formData.name.$model"
                :disabled="viewMode"
              />
              <div v-if="$v.formData.name.$dirty" class="text-danger">
                <div class="error" v-if="!$v.formData.name.required">
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <base-input label="Code" required>
              <a-input
                v-model.trim="$v.formData.code.$model"
                :disabled="viewMode || paymentTypeData !== null"
              />
              <div v-if="$v.formData.code.$dirty" class="text-danger">
                <div class="error" v-if="!$v.formData.code.required">
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Status" required>
              <a-select v-model="formData.status" :disabled="viewMode">
                <a-select-option value="A"> Active</a-select-option>
                <a-select-option value="I"> Inactive</a-select-option>
              </a-select>
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input>
              <b-form-checkbox
                v-model="formData.hasRemarks"
                name="check-button"
                @change="onChangeRequireRemarks"
                switch
                :disabled="viewMode"
              >
                <label class="form-control-label">
                  Require Payment Remarks
                </label>
              </b-form-checkbox>
            </base-input>
          </div>
        </div>

        <div class="row" v-if="showHint">
          <div class="col">
            <base-input label="Remarks Input Guide">
              <a-input v-model="remarks_hint_text" :disabled="viewMode" />
            </base-input>
          </div>
        </div>
      </div>
      <div
        style="
          position: absolute;
          bottom: 0px;
          right: 0px;
          width: -webkit-fill-available;
          background-color: #f2f2f2;
          padding: 10px;
        "
      >
        <div class="container mx-0 px-0">
          <div class="row">
            <div class="col-auto mr-auto">
              <b-button
                size="sm"
                class="float-md-left"
                style="margin-left: 8px"
                @click.prevent="closeDrawer"
              >
                Cancel
              </b-button>
            </div>
            <div class="col-auto">
              <template>
                <a-spin :spinning="formSubmitting">
                  <b-button
                    v-if="paymentTypeData === null"
                    size="sm"
                    variant="primary"
                    @click.prevent="createPaymentType"
                  >
                    Create
                  </b-button>

                  <b-button
                    v-else
                    size="sm"
                    variant="primary"
                    @click.prevent="editPaymentType"
                    :disabled="viewMode"
                  >
                    Update
                  </b-button>
                </a-spin>
              </template>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'PaymentTypeForm',
  props: {
    paymentTypeData: Object,
    viewMode: Boolean
  },
  data() {
    return {
      formSubmitting: false,
      showHint: false,
      remarks_hint_text: null,
      formData: {
        name: null,
        code: null,
        hasRemarks: false,
        extras: null,
        status: null
      }
    };
  },
  validations: {
    formData: {
      name: { required },
      code: { required }
    }
  },
  methods: {
    onChangeRequireRemarks(hasRemarks) {
      this.showHint = hasRemarks;
    },
    async createPaymentType() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        let jsonData = this.formData.extras
          ? JSON.parse(this.formData.extras)
          : {};
        jsonData.hasRemarks = this.formData.hasRemarks ? true : false;
        jsonData.remarks_hint_text = this.showHint
          ? this.remarks_hint_text
          : '';
        this.formData.extras = JSON.stringify(jsonData);
        const response = await HTTPRequest.postRequest(
          '/api/v1/payment_types',
          {
            payment_type: this.formData
          }
        );

        if (response.id) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Success',
            description: 'Data has been created.'
          });
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }
        this.formSubmitting = false;
      }
    },
    async editPaymentType() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        let jsonData = this.formData.extras
          ? JSON.parse(this.formData.extras)
          : {};
        jsonData.hasRemarks = this.formData.hasRemarks ? true : false;
        jsonData.remarks_hint_text = this.showHint
          ? this.remarks_hint_text
          : '';
        this.formData.extras = JSON.stringify(jsonData);

        this.formSubmitting = true;
        const response = await HTTPRequest.putRequest(
          '/api/v1/payment_types/' + this.paymentTypeData.id,
          {
            payment_type: this.formData
          }
        );

        if (response.id) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Success',
            description: 'Data has been updated.'
          });
        } else {
          this.$notification.error({
            message: 'Error',
            description: 'Something went wrong. Please try again.',
            placement: 'topLeft'
          });
        }

        this.formSubmitting = false;
      }
    },
    closeDrawer() {
      this.clearForm();
      this.$emit('closeDrawer', null);
      this.$v.formData.$reset();
    },
    clearForm() {
      this.showHint = false;
      this.remarks_hint_text = null;
      this.formData = {
        name: null,
        code: null,
        extras: null,
        hasRemarks: false,
        status: null
      };
    },
    setFormData(data = null) {
      if (data !== null) {
        const { name, code, status, extras } = data;
        const jsonData = extras ? JSON.parse(extras) : null;
        this.formData = {
          name,
          code,
          status,
          extras
        };
        this.formData.hasRemarks =
          jsonData && jsonData.hasRemarks ? jsonData.hasRemarks : false;

        this.showHint = this.formData.hasRemarks;
        this.remarks_hint_text =
          jsonData && jsonData.remarks_hint_text
            ? jsonData.remarks_hint_text
            : null;
      } else {
        this.clearForm();
      }
    }
  },
  created() {
    this.setFormData(this.paymentTypeData);
  },
  watch: {
    paymentTypeData: function (data) {
      this.setFormData(data);
    },
    remarks_hint_text: function (newVal) {
      this.remarks_hint_text = newVal;
    }
  }
};
</script>

<style scoped></style>
